var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissingParkingWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8867 15.3228C19.1796 15.0299 19.1796 14.555 18.8867 14.2622C18.5938 13.9693 18.119 13.9693 17.8261 14.2622L15.6555 16.4327L13.485 14.2622C13.1921 13.9693 12.7172 13.9693 12.4243 14.2622C12.1314 14.555 12.1314 15.0299 12.4243 15.3228L14.5949 17.4934L12.4243 19.6639C12.1314 19.9568 12.1314 20.4317 12.4243 20.7246C12.7172 21.0175 13.1921 21.0175 13.485 20.7246L15.6555 18.554L17.8261 20.7246C18.119 21.0175 18.5938 21.0175 18.8867 20.7246C19.1796 20.4317 19.1796 19.9568 18.8867 19.6639L16.7162 17.4934L18.8867 15.3228Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.207 3H7C6.44772 3 6 3.44772 6 4V15.9681C6 16.5204 6.44772 16.9681 7 16.9681H7.97545C8.52773 16.9681 8.97545 16.5204 8.97545 15.9681V12.3121H11.207C13.6692 12.3121 15.6702 10.2246 15.6702 7.65603C15.6702 5.08745 13.6692 3 11.207 3ZM11.3558 9.20804H8.97545V6.10402H11.3558C12.1741 6.10402 12.8435 6.80242 12.8435 7.65603C12.8435 8.50963 12.1741 9.20804 11.3558 9.20804Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingParkingWhite);
export default __webpack_public_path__ + "static/media/missing-parking-white.5126b808f38acb6d0a10fdd9d4fa792a.svg";
export { ForwardRef as ReactComponent };